import moment from 'moment';


const safeMomentDate = (date) => {
  const result = moment(date);
  if (result.isValid()) {
    return result;
  }
  return undefined;
};

export { safeMomentDate };
